export default function BrandAside() {
  return (
    <aside className="hidden lg:flex relative w-full h-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20botanical%20still%20life%20with%20freshly%20cut%20garden%20flowers%2C%20wild%20greenery%20and%20blooms%20in%20soft%20cream%20and%20deep%20green%20tones%2C%20editorial%20fine%20art%20photography%2C%20warm%20natural%20light%2C%20minimal%20quiet%20composition%2C%20rich%20texture%20and%20calm%20mood&width=900&height=1200&seq=members-login-botanical-01&orientation=portrait"
          alt="Freshly cut garden flowers and greenery in soft natural light"
          title="Hillsborough Garden Club members portal"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-900/55 to-primary-900/30" />

      <div className="relative z-10 flex flex-col justify-end w-full p-10 xl:p-14">
        <div className="max-w-md">
          <p className="text-[11px] uppercase tracking-[0.32em] text-accent-300">Members Portal</p>
          <h2 className="mt-4 font-heading text-3xl xl:text-4xl leading-tight text-background-50">
            Welcome back to the garden.
          </h2>
          <p className="mt-5 text-sm xl:text-base text-background-200/90 leading-relaxed">
            Sign in to access member directories, meeting notes, event calendars
            and the club's shared garden resources.
          </p>
          <div className="mt-8 h-px w-16 bg-accent-400/70" />
          <p className="mt-6 text-xs text-background-200/70">
            A member of The Garden Club of America
          </p>
        </div>
      </div>
    </aside>
  );
}